import React, { useEffect, useState } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import { apiFetch } from './api';

const THEME_COLORS = ['#2563eb', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

function Charts({ tenantId }) {
  const [jobData, setJobData] = useState([]);
  const [notifData, setNotifData] = useState([]);

  useEffect(() => {
    apiFetch(`/history/jobs?limit=100&tenant_id=${tenantId}`)
      .then(res => res.json())
      .then(data => setJobData(data.events || []));
    apiFetch(`/history/notifications?limit=100&tenant_id=${tenantId}`)
      .then(res => res.json())
      .then(data => setNotifData(data.notifications || []));
  }, [tenantId]);

  const jobTypes = {};
  jobData.forEach(row => {
    const type = row[1];
    jobTypes[type] = (jobTypes[type] || 0) + 1;
  });

  const notifChannels = {};
  notifData.forEach(row => {
    const channel = row[3];
    notifChannels[channel] = (notifChannels[channel] || 0) + 1;
  });

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { 
        position: 'bottom',
        labels: { 
          color: '#475569', 
          font: { family: 'Outfit', size: 12, weight: '600' },
          padding: 20,
          usePointStyle: true
        } 
      }
    },
    scales: {
      x: { 
        grid: { display: false }, 
        ticks: { color: '#64748b', font: { family: 'Outfit', weight: '500' } } 
      },
      y: { 
        grid: { color: '#f1f5f9' }, 
        ticks: { color: '#64748b', font: { family: 'Outfit' } } 
      }
    }
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2.5rem' }}>
      <div className="stat-card" style={{ padding: '1.5rem', height: '350px' }}>
        <h4 style={{ marginBottom: '1.5rem', color: 'var(--text-primary)', fontWeight: '700', fontSize: '1.1rem' }}>Distribuição de Tarefas</h4>
        <div style={{ height: '260px' }}>
          <Bar
            options={chartOptions}
            data={{
              labels: Object.keys(jobTypes),
              datasets: [{ 
                label: 'Ocorrências', 
                data: Object.values(jobTypes),
                backgroundColor: '#2563eb',
                borderRadius: 6,
                barThickness: 25
              }]
            }}
          />
        </div>
      </div>
      <div className="stat-card" style={{ padding: '1.5rem', height: '350px' }}>
        <h4 style={{ marginBottom: '1.5rem', color: 'var(--text-primary)', fontWeight: '700', fontSize: '1.1rem' }}>Canais de Notificação</h4>
        <div style={{ height: '260px' }}>
          <Pie
            options={{ ...chartOptions, scales: {} }}
            data={{
              labels: Object.keys(notifChannels),
              datasets: [{ 
                data: Object.values(notifChannels),
                backgroundColor: THEME_COLORS,
                borderColor: '#ffffff',
                borderWidth: 2
              }]
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Charts;
